<template>
  <mini-card :value="'$'+totalPendingPayouts" subtitle="Pending" :previousValue="'$'+totalPendingPayoutsPrevious">
    <div slot="header" class="icon-warning">
      <i class="fad fa-money-check-edit text-primary"></i>
    </div>
    <template slot="footer">
      <center class="row ml-0">
        <button @click="requestPayoutSubmission()"
        class="btn btn-primary col-6"
        v-tooltip.center-top="'Request Payouts to be Submitted for Payment'">
          Request
        </button>
        <Row-Selection-Checkbox class="col-6 ml-auto"
                                v-tooltip.center-top="'Exclude some Payouts from the Request'"
                                :filter="{status: $store.getters.Payout._status.PENDING.value,
                                          archived: false}">
          Exclude
        </Row-Selection-Checkbox>
      </center>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-Pending-MiniCard',
  components: {
    MiniCard
  },
  methods: {
    requestPayoutSubmission () {
      this.$store.dispatch('openModal', { name: 'Payouts Confirmation', mode: 'Request Submission'})
    }
  },
  computed: {
    totalPendingPayouts () {
      return this.$store.getters.totalPayouts({status: Payout._status.PENDING})
    },
    totalPendingPayoutsPrevious () {
      return this.$store.getters.totalPayoutsPrevious({status: Payout._status.PENDING})
    }
  }
}
</script>

<style>

</style>